import React,{useState} from 'react';
import {Form,Col,Container,Table,Button,Modal} from 'react-bootstrap';
import memory_data from './memory.json'
class Popup extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            
        }
        this.handleCheck = this.handleCheck.bind(this)
        this.handleExit = this.handleExit.bind(this)
        this.handleSuccess = this.handleSuccess.bind(this)
        //this.handleClose = this.handleClose.bind(this)
    }
    handleDefault(){
        memory_data.map( (m,i) =>
            this.setState(prevState =>({
                ...prevState,
                ['1stTrial_memory_'+m]:false,
                ['2ndTrial_memory_'+m]:false,
                
            })),)
    }
    componentDidMount(){
        if(this.props.data==null){
            this.handleDefault()
        }
        else if(this.props.data!=null){
            memory_data.map((m,i)=>{
                this.setState(prevState =>({
                    ...prevState,
                    ['1stTrial_memory_'+m]:(this.props.data['1stTrial_memory_'+m] ==1?true:false),
                    ['2ndTrial_memory_'+m]:(this.props.data['1stTrial_memory_'+m]==1?true:false)
                    
                }))
            })
        }
        
        // this.handleDefault()
    
        

    }
    handleSubmit(){

    }
    handleExit(){
        if (this.props.data== null){
            this.handleDefault()
        }
        this.props.handleClose()
    }
    componentDidUpdate(prevProps,prevState){
        if (prevState != this.state){
        }
    }
    async handleCheck(event){
        const {name, checked}  =event.target
       
        await this.setState((prevState)=>(
        {
            ...prevState,
            [name]:checked
        }
        ))
    }
    handleSuccess(){
        const data = this.state
        this.props.handlePopup({data})
        this.props.handleClose()
    }
    render() {
        return(
            <Modal show={this.props.show} onHide={this.props.handleClose} size={'lg'} onHide={this.handleExit}>
            <Modal.Header closeButton>
                <Modal.Title>Memory</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Table>
                    <thead>
                        <tr>
                            <th>Trial</th>
                            {memory_data.map((m,index)=>(
                                <th key={index}>{m}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            
                            <td>1st Trial</td>
                            {memory_data.map((m,index)=>
                             
                             <td key={index}>
                                 <Form.Group>
                                     <Form.Check type="checkbox" name={'1stTrial_memory_'+m} onChange={this.handleCheck} checked={this.state['1stTrial_memory_'+m] } disabled={this.props.disabled}/>
                                 </Form.Group>
                             </td>
                         
                     )}
                        </tr>
                        <tr>
                            <td>2nd Trial</td>
                            {memory_data.map((m,index)=>
                             
                             <td key={index}>
                                 <Form.Group>
                                     <Form.Check type="checkbox" name={'2ndTrial_memory_'+m} onChange={this.handleCheck} checked={this.state['2ndTrial_memory_'+m]} disabled={this.props.disabled}/>
                                 </Form.Group>
                             </td>
                         
                     )}
                        </tr>
                        
                    </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="success" onClick={this.handleSuccess}>Save changes</Button>
            </Modal.Footer>
        </Modal>
        )
    }
}
Popup.defaultProps = {
    data:null
}
export default Popup;